import Card from 'Views/Components/_HumanWritten/Card/Card';
import { Flex } from 'Views/Components/Flex/Flex';
import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import { RegisterCustomerFields } from './RegisterCustomerFields';
import { useRegisterCustomerForm } from './useRegisterCustomerForm';

export interface RegisterCustomerFormProps {
	/**
	 * This function will trigger the next step in RegisterCustomer component.
	 */
	next: (email: string, userId: string) => void;
}

function RegisterCustomerFormContent({ next }: RegisterCustomerFormProps) {
	const navigate = useNavigate();
	const { userEntity, errors, loading, registerAsCompany, setRegisterAsCompany, revalidate, submit } =
		useRegisterCustomerForm();

	const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const customer = await submit();
		if (customer) {
			next(customer.email, customer.id);
		}
	};

	return (
		<form onSubmit={onSubmit}>
			<Card>
				<h5>Register a new customer</h5>
				<RegisterCustomerFields
					userEntity={userEntity}
					errors={errors}
					onAfterChange={revalidate}
					registerAsCompany={registerAsCompany}
					onRegisterAsCompanyChange={setRegisterAsCompany}
				/>
				<Flex gap="xs">
					<Button
						display={Display.Outline}
						colors={Colors.Secondary}
						newStyles
						buttonProps={{ id: 'back_btn', style: { flex: 2 } }}
						onClick={() => navigate(-1)}
					>
						Back
					</Button>
					<Button
						type="submit"
						display={Display.Solid}
						colors={Colors.Primary}
						newStyles
						buttonProps={{ id: 'continue_btn', style: { flex: 5 } }}
						disabled={loading}
					>
						{loading ? 'Loading...' : 'Continue'}
					</Button>
				</Flex>
			</Card>
		</form>
	);
}

// Observer is required so the fields re-render when the model values / validation errors change.
export const RegisterCustomerForm = observer(RegisterCustomerFormContent);
